import type { Phase } from "../hooks/useCycles";

type RetrievalPhase = Pick<Phase, "startDate" | "endDate"> & {
  fertilityMetrics?:
    Pick<NonNullable<Phase["fertilityMetrics"]>[number], "type">[] | null;
};

/**
 * Whether the egg retrieval is still to come: booked for a later day, or for
 * today with nothing recording it yet.
 *
 * The retrieval phase is current from the morning of its start date, so reading
 * the date alone said "Retrieval done" and moved Home on to recovery while she
 * was still fasting for it. A retrieval booked for today counts as done once its
 * step is closed or the eggs collected are recorded, and from the next day
 * either way.
 */
export function isRetrievalStillAhead(
  phase: RetrievalPhase | null | undefined,
  todayIso: string,
): boolean {
  if (!phase?.startDate || phase.startDate < todayIso) return false;
  if (phase.startDate > todayIso) return true;
  if (phase.endDate) return false;
  return !(phase.fertilityMetrics ?? []).some(
    (metric) => metric.type === "retrieved_oocytes",
  );
}
